<template>
  <div class="row border rounded p-2 d-flex align-items-center">
    <div class="col smalltxt" v-for="s in summary" :key="s.pool_id">
      {{ s.pool_name }} :
      <span class="fw-bold text-success">{{ s.purchased }}</span
      >/<span class="text-muted">{{ s.count }}</span>
    </div>
  </div>
</template>
<script setup>
import { defineProps, ref, onMounted, computed } from "vue";
import supabase from "@/supabase/config";
import { useStore } from "@/store/index";
const props = defineProps(["team_id"]);
const store = useStore();
const players_list = ref([]);
const pools_list = ref([]);
onMounted(() => {
  fetchPlayers();
  fetchPools();
});
const fetchPools = async () => {
  let { data: pools, error } = await supabase
    .from("pools")
    .select("*")
    .eq("auction_id", store.live_auction);
  pools_list.value = pools;
};
const fetchPlayers = async () => {
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("team_id", props.team_id);
  players_list.value = players;
};
const sorted_list = computed(() => {
  const arr = [];
  players_list.value.forEach((p) => {
    arr.push(p);
  });
  var sorted_arr = [...arr].sort(
    (a, b) => new Date(b.sold_at) - new Date(a.sold_at)
  );
  return sorted_arr;
});
const summary = computed(() => {
  var arr = [];
  pools_list.value.forEach((p) => {
    //str = str + p.name;
    var pool_count = players_list.value.filter(
      (obj) => obj.pool_id === p.id
    ).length;
    arr.push({
      pool_name: p.name,
      pool_id: p.id,
      condition: p.count_condition,
      count: p.count,
      sort: p.sort,
      purchased: pool_count,
    });
  });
  var sorted_arr = [];
  sorted_arr = [...arr].sort((a, b) => a.sort - b.sort);
  return sorted_arr;
});
</script>
<style scoped>
.smalltxt {
  font-size: 12px;
}
</style>
